// alertUtility.js
export function SuccessAlert(message) {
  const alertBox = document.createElement("div");

  // Format the message: Capitalize first letter, lowercase the rest
  const formattedMessage = message
  ? message
      .replace(/^([^a-zA-Z]*)([a-zA-Z])(.*)$/, (_, prefix, first, rest) =>
        prefix + first.toUpperCase() + rest
      )
      .replace(/([.!?]\s+)([a-zA-Z])/g, (_, separator, letter) =>
        separator + letter.toUpperCase()
      )
  : "";

  // Set the HTML content
  alertBox.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" rx="5" fill="#E3F3FF"/>
        <path d="M28 14L17 25L12 20" stroke="#165D31" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="alert-message ftw-4 common-text">${formattedMessage}</span>
      </div>
    `;

  // Style the alert container
  alertBox.style.position = "fixed";
  alertBox.style.left = "50%";
  alertBox.style.top = "100px";
  alertBox.style.transform = "translateX(-50%)";
  alertBox.style.backgroundColor = "#FFF";
  // alertBox.style.border = '1px solid rgba(255, 0, 0, 0.20)';
  // alertBox.style.boxShadow = '0px 8px 15px 0px rgba(255, 0, 0, 0.20)';
  alertBox.style.borderRadius = "13px";
  alertBox.style.padding = "12px 16px";
  alertBox.style.boxSizing = "border-box";
  alertBox.style.zIndex = "999999";
  alertBox.style.animation = "slideDown 0.3s ease-out forwards";
  alertBox.style.boxShadow = "0 13px 27px 0 rgba(0, 0, 0, 0.10)";

  // Add animation keyframes
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
      .alert-message {
        font-size: 0.875rem;
      }
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
        to {
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }
      @keyframes fadeOut {
        from {
          opacity: 1;
          transform: translate(-50%, 0);
        }
        to {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
      }
      
    `;
  document.head.appendChild(styleSheet);

  // Add the alert to the page
  document.body.appendChild(alertBox);

  // Add the alert-box class to the alertBox element
  alertBox.classList.add("alert-box");

  // Remove the alert after 3 seconds
  setTimeout(() => {
    alertBox.style.animation = "fadeOut 0.3s ease-out forwards";
    setTimeout(() => {
      document.body.removeChild(alertBox);
      document.head.removeChild(styleSheet);
    }, 300);
  }, 3000);
}
